import {Component, OnInit, ViewChild} from '@angular/core';

import { PublisherService } from '../publisher/publisher.service';
import {LoadingModal} from '../modals/modal-loading.component';
import {ShowErrorModal} from '../modals/modal-error.component';
import {ModalErrorArgs} from '../modals/modal-error-args';
import {ModalService} from '../modals/modal.service';
import {Subscription} from 'rxjs/Subscription';
import { TargetValidationDialog } from './target-validation/target-validation-dialog.component';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss',
        '../../../node_modules/bootstrap/dist/css/bootstrap.css'
    ]
})
export class DashboardComponent implements OnInit {

    @ViewChild('targetValidationDialog') private targetValidationModal: TargetValidationDialog
    @ViewChild('errorModal') private errorModal: ShowErrorModal;
    @ViewChild('loadingModal') private loadingModal: LoadingModal;
    modalSubscription: Subscription;

    constructor(
        private publisherService: PublisherService,
        private modalService: ModalService
    ) {
      this.modalSubscription = this.modalService.modalChanged
          .subscribe((change: any) => {
            if(change.showLoading === true){
                this.showLoadingProgress(change.value, change.showStopTest, change.showOkButton);
            }
              if(change.showLoading === false){
                  this.hideLoadingProgress();
              }
          });
    }

    ngOnInit() {

    }

    showLoadingProgress(value: string, showButton: boolean, showOkButton: boolean) {
        if(!this.loadingModal.isOn){
            this.loadingModal.showDialog(value);
            this.loadingModal.setShowStopTest(showButton);
            this.loadingModal.setShowOkButton(showOkButton);
        } else {
            this.loadingModal.updateDialog(value);
            this.loadingModal.setShowStopTest(showButton);
            this.loadingModal.setShowOkButton(showOkButton);
        }

    }

    hideLoadingProgress() {
        this.loadingModal.closeDialog();
    }

    showErrorModal() {
        this.errorModal.showDialog(new ModalErrorArgs('error', 'Cannot Update Tool'));
    }

    hideErrorModal() {
        this.errorModal.closeDialog();
    }

    onButtonPush() {

    }
}



// WEBPACK FOOTER //
// ./src/app/main/dashboard.component.ts